import { Alert } from "react-bootstrap";

export default function PayoutDisclaimer() {
    return (
        <Alert variant="warning" className="mb-2">
            <small className="fst-italic">
                <strong>Disclaimer:</strong> Payouts are recorded on the booking's check-in date. All payout amounts shown are gross amounts and do not include expenses, fees, or other deductions.
            </small>
        </Alert>
    )
}